const { isEnv } = require("simpul");
const { domain } = require("./url");
const port = require("./port");

const origin = isEnv.production ? domain : "http://localhost:" + port.client;

module.exports = origin;
